// extracted by mini-css-extract-plugin
module.exports =  {"pluginContainer":"AiAssistantChatWrapper-module__pluginContainer--mR"};